import { Component, OnInit, Input } from '@angular/core';
import { DbRecord } from '../db-record'
import { RuntimeService } from '../runtime.service'

@Component({
  selector: 'app-patent-family',
  templateUrl: './patent-family.component.html',
  styleUrls: ['./patent-family.component.css']
})
export class PatentFamilyComponent implements OnInit {
  @Input() dbRecord: DbRecord;
  familyRecords: DbRecord[]
  expandedSet = new Set<string>()
  isSummary = true

  constructor(
    private rs: RuntimeService
  ) { }

  get project() {
    return this.rs.currentProject
  }

  ngOnInit() {
    this.familyRecords = this.dbRecord.patentFamily
  }

  expandSwitch(dbrId: string) {
    if (!this.expandedSet.delete(dbrId))
      this.expandedSet.add(dbrId)
  }


  isExpanded(dbrId: string) {
    return this.expandedSet.has(dbrId)
  }

  switchSummary() {
    this.isSummary = !this.isSummary
  }

}



// WEBPACK FOOTER //
// ./src/app/patent-family/patent-family.component.ts